module.exports = __webpack_public_path__ + "img/015-hippopotamus.ae2e0332.svg";